<template>
  <div class="DataTable">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>

    <v-container fluid>
      <!-- <div class="addingItemComponentForm"> -->
      <v-form ref="form1" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs2 pa-2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="dateFormatted"
                label="Datum"
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                @blur="date = parseDate(dateFormatted)"
              ></v-text-field>
              <v-date-picker
                v-model="date"
                no-title
                @input="menu = false"
                :max="maxDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs1 pa-2>
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="0"
              :return-value.sync="time"
              transition="scale-transition"
              lazy
              offset-y
              full-width
              min-width="290px"
              @input="
                (value) =>
                  value && $refs.picker && ($refs.picker.selectingHour = true)
              "
              :disabled="!edit_form"
            >
              <v-text-field
                slot="activator"
                v-model="time"
                label=""
                readonly
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
              ></v-text-field>
              <v-time-picker
                v-model="time"
                ref="picker"
                full-width
                landscape
                class="mt-3"
                format="24hr"
                :allowed-minutes="allowedStep"
                v-on:change="$refs.menu1.save(time)"
              >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu1 = false"
                  >Cancel</v-btn
                >
                <!-- <v-btn flat color="primary" @click="$refs.menu1.save(time)">OK</v-btn> -->
              </v-time-picker>
            </v-menu>
          </v-flex>
          <v-flex xs4 pa-2> </v-flex>
          <v-flex xs5 pa-2>
            <!-- <v-text-field
              v-model="give"
              label="Predao"
              persistent-hint
              return-object
            ></v-text-field>-->

            <v-autocomplete
              ref="element1"
              v-model="give_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Izvršio"
              persistent-hint
              return-object
              :disabled="!edit_form"
              required
              :rules="[(v) => !!v || 'Obavezan podatak']"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-form>
      <v-form ref="form" v-model="valid" lazy-validation>
        <!-- <v-layout row wrap>
          <v-flex xs5 pa-2>
            <v-autocomplete
              v-model="give_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              item-value="id"
              label="Predao"
              persistent-hint
              return-object
              :disabled="!edit_form"
            ></v-autocomplete>
          </v-flex>
        </v-layout> -->
        <v-layout row wrap>
          <!-- <v-flex xs12 pa-2>
            <v-textarea v-model="opis" name="input-5-1" class="Description" label="Opis"></v-textarea>
          </v-flex> -->
          <v-flex xs12 pa-2>
            <v-text-field
              v-model="opis"
              label="Opis"
              :disabled="!edit_form"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 pa-2 style="text-align: center">
            <v-btn
              id="HistoryButton"
              @click="otvoriModal"
              v-if="edit_form && !executed_document"
            >
              <p>
                <v-icon>close</v-icon>
              </p> </v-btn
            ><!-- /#HistoryButton -->
          </v-flex>
        </v-layout>

        <v-layout column>
          <v-flex style="overflow: auto">
            <v-data-table
              :headers="headers_modal"
              :items="items_modal_pom"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props_modal">
                <td v-if="props_modal.item.wineName !== undefined">
                  {{ props_modal.item.wineName }} -
                  {{ props_modal.item.wineYear }}
                </td>
                <td v-else>
                  {{ props_modal.item.wine.label }} -
                  {{ props_modal.item.wine.year }}
                </td>
                <!-- <td>
                  {{
                    formatDateTime(
                      props_modal.item.warehouseState.dateOfProduction
                    )
                  }}
                </td> -->
                <td v-if="props_modal.item.lot !== undefined">
                  {{ props_modal.item.lot }}
                </td>
                <td v-else>
                  {{ props_modal.item.warehouseState.lot }}
                </td>
                <!-- <td>
                  {{ props_modal.item.warehouseState.tank }}
                </td> -->
                <td v-if="props_modal.item.bottleVolumeInLitres !== undefined">
                  {{ props_modal.item.bottleVolumeInLitres }}
                </td>
                <td v-else>
                  {{ props_modal.item.warehouseState.bottleVolumeInLitres }}
                </td>
                <td>
                  {{ props_modal.item.quantity }}
                </td>

                <td
                  class="DataTable__ButtonHolder"
                  style="text-align: center; padding-left: 0px !important"
                >
                  <img
                    v-if="edit_form"
                    class="DataTable__Button"
                    title="Izmena"
                    src="../assets/icons/zatabele/ico-edit2.svg"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item, true)"
                  />
                  <img
                    v-else
                    class="DataTable__Button"
                    title="Pregled"
                    src="../assets/icons/zatabele/ico-view.png"
                    alt="ulaz-grozdja"
                    @click="editItemModal(props_modal.item, true)"
                  />
                  <img
                    class="DataTable__Button"
                    title="Pregled izdantnica"
                    src="../assets/icons/zatabele/ico-add.svg"
                    alt="delete-item"
                    @click="otvoriModalRepromaterijal(props_modal.item)"
                    v-if="edit_form"
                  />
                  <img
                    class="DataTable__Button"
                    title="Brisanje"
                    src="../assets/icons/zatabele/ico-delete2.svg"
                    alt="delete-item"
                    @click="deleteItemModalPom(props_modal.item)"
                    v-if="edit_form && !executed_document"
                  />
                </td>
              </template>
              <template slot="no-data">
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="primary"
                  icon="info"
                  >Nema podataka.</v-alert
                >
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex
            xs12
            style="text-align: right; margin-bottom: 0px; padding-top: 15px"
          >
            <v-btn
              :disabled="!valid"
              @click="submit"
              class="AppButtonFilled"
              v-if="edit_form"
              >Sačuvaj</v-btn
            >
            <v-btn
              id="Odustani_dugme"
              @click="clear"
              class="AppButtonOutlined"
              v-if="edit_form"
              >odustani</v-btn
            >
          </v-flex>
        </v-layout>
      </v-form>

      <v-dialog
        v-model="dialogNote"
        scrollable
        content-class="ModalInModalMali"
      >
        <v-container>
          <div class="DataTable">
            <v-form ref="form_modal" v-model="validModal" lazy-validation>
              <a
                class="closeModalInModalBtn"
                @click.prevent="closeModalInModal"
              >
                <v-icon>close</v-icon>
              </a>
              <!-- /.closeModalBtn -->
              <v-layout row wrap>
                <v-flex xs12 pa-2>
                  <v-autocomplete
                    v-model="article_to_select"
                    :items="article_to_items"
                    :item-text="getFieldTextWine"
                    item-value="id"
                    label="Vino"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    v-on:change="changeWine"
                    :disabled="!edit_form"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs8 pa-2 v-if="edit_form">
                  <v-autocomplete
                    v-model="wh_state_to_select"
                    :items="wh_state_to_items"
                    :item-text="getFieldTextBottling"
                    item-value="stateId"
                    label="Lot - Stanje boca"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs8 pa-2 v-else>
                  <v-text-field
                    v-model="pomocni_text"
                    label="Lot - Stanje boca"
                    persistent-hint
                    return-object
                    disabled
                  ></v-text-field>
                </v-flex>
                <!-- </v-layout>
            </v-form>
            <v-form ref="form_modal_1" v-model="validModal" lazy-validation>
              <v-layout row wrap> -->
                <v-flex xs3 pa-2>
                  <v-text-field
                    v-model="quantity"
                    label="Broj boca"
                    type="number"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    :disabled="!edit_form"
                  ></v-text-field>
                </v-flex>

                <v-flex xs1 style="padding-left: 0px">
                  <v-icon
                    slot="activator"
                    id="FloatingButton"
                    @click="otvoriModalRepromaterijal(null)"
                    title="Repromaterijal"
                    >add</v-icon
                  >
                </v-flex>
                <!-- <v-flex xs2 pa-2>
                  <v-autocomplete
                    v-model="jm_select"
                    :items="jm_items"
                    item-text="mark"
                    item-value="id"
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    label="JM"
                    required
                    persistent-hint
                    return-object
                    :disabled="true"
                  ></v-autocomplete>
                </v-flex> -->
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs12
                  style="
                    text-align: right;
                    margin-bottom: 0px;
                    padding-top: 15px;
                  "
                >
                  <v-btn
                    :disabled="!validModal"
                    @click="submit_modal"
                    class="AppButtonFilled"
                    v-if="edit_form"
                    >Sačuvaj</v-btn
                  >
                  <v-btn
                    @click="clear_modal"
                    class="AppButtonOutlined"
                    v-if="edit_form"
                    >odustani</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <!-- /.addingToTank -->
        </v-container>
      </v-dialog>

      <v-dialog
        v-model="dialogNoteIzdatnice"
        scrollable
        content-class="ModalInModal"
      >
        <v-container style="padding: 0px">
          <div class="DataTable">
            <div data-v-fae5bece class="v-card">
              <div
                data-v-fae5bece
                class="v-card__title headline lighten-2 v-card__title--primary"
                style="padding-left: 30px; padding-bottom: 0px"
              >
                <div>
                  Izdatnice za izbor - {{ this.selectedArticleName }}
                  {{ parseFloat(this.additiveQuantity).toFixed(brojDec) }}
                  {{ this.jm === "psc" ? "kom" : this.jm }}
                </div>

                <button
                  id="closeModalBtn"
                  @click.prevent="closeModal"
                  class="v-btn v-btn--flat white"
                >
                  <v-icon>close</v-icon>
                </button>
              </div>

              <div data-v-fae5bece class="spacer"></div>

              <MyComponent
                @newdata="handleData($event)"
                @close="handleDataClose($event)"
                :articleId="selectedArticle"
                :documentId="documentID"
                operation="LAUNCH_ADDITIVE"
                :unitOfMeasureId="jm_select"
                :additiveQuantity="additiveQuantity"
                :ID="0"
                :izabrani_aditiv="izabrani_aditivi"
                :dodavanje_novog="dodavanje_novog"
                :edit="edit_form"
              ></MyComponent>
            </div>
          </div>
          <!-- /.addingToTank -->
        </v-container>
      </v-dialog>

      <v-dialog
        v-model="dialogNoteRepromaterijal"
        scrollable
        content-class="ModalInModal"
      >
        <v-container>
          <div class="DataTable">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              style="
                padding-left: 10px;
                padding-bottom: 0px;
                padding-top: 0px;
                padding-right: 0px;
                font-size: 18px !important;
              "
            >
              <!-- Modal Titles  -->

              <div>Repromaterijal</div>

              <button
                id="closeModalInModalBtn"
                @click.prevent="closeModalInModalRepromaterijal"
                class="v-btn v-btn--flat white"
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>
            <v-form
              ref="form_modal_repromaterijal"
              v-model="valid1"
              lazy-validation
            >
              <v-layout row wrap>
                <v-flex xs3 pa-2>
                  <v-select
                    v-model="additiv_group_to_select"
                    :items="additiv_group_to_items"
                    item-text="name"
                    item-value="id"
                    label="Grupa"
                    persistent-hint
                    return-object
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    required
                    v-on:change="changeAditiveGroup"
                  ></v-select>
                </v-flex>
                <v-flex xs4 pa-2>
                  <v-autocomplete
                    v-model="aditiv_select"
                    :items="aditiv_items"
                    item-text="name"
                    item-value="id"
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    label="Repromaterijal"
                    required
                    persistent-hint
                    return-object
                    v-on:change="getAllJediniceMereAditiv"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  xs1
                  pa-2
                  style="
                    padding-top: 20px !important;
                    padding-left: 0px !important;
                    padding-top: 20px !important;
                  "
                  v-if="1===2"
                >
                  <v-icon
                    slot="activator"
                    @click="otvoriSifarnik"
                    style="color: #018389; padding-left: 0px; font-weight: bold"
                    title="Dodavanje repromaterijala"
                    v-if="edit_form && additiv_group_to_select !== undefined"
                    >add</v-icon
                  >
                </v-flex>
                <v-flex xs2 pa-2>
                  <v-text-field
                    v-model="kolicina_modal"
                    label="Količina"
                    @keypress="filter"
                    min="0"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs2 pa-2>
                  <v-select
                    v-model="jm_select"
                    :items="jm_items_dodatak"
                    :item-text="getFieldTextJM"
                    item-value="id"
                    :rules="[(v) => !!v || 'Obavezan podatak']"
                    label="JM"
                    required
                    persistent-hint
                    return-object
                  ></v-select>
                </v-flex>
                <v-flex xs1 style="padding-left: 0px" v-if="edit_form">
                  <v-icon
                    slot="activator"
                    id="FloatingButton"
                    @click="submit_parameter"
                    title="Spisak izdatnica"
                    >add</v-icon
                  >
                </v-flex>
              </v-layout>
              <!-- /.Datepicker -->

              <v-layout row wrap>
                <v-flex xs12 pa-2>
                  <v-textarea
                    v-model="opis_modal"
                    name="input-5-1"
                    class="Description"
                    label="Opis"
                  ></v-textarea>
                </v-flex>
                <!-- /.Dodatak Input -->
              </v-layout>

              <v-layout row wrap>
                <v-flex xs12>
                  <v-btn
                    :disabled="!valid1 || !edit_form"
                    @click="submit_modal_repromaterijal"
                    class="AppButtonFilled"
                    >Sačuvaj</v-btn
                  >
                  <v-btn
                    :disabled="!edit_form"
                    @click="clear_modal_repromaterijal"
                    class="AppButtonOutlined"
                    >odustani</v-btn
                  >
                </v-flex>
              </v-layout>
              <!-- /.Action buttons -->
              <v-layout column>
                <v-flex style="overflow: auto">
                  <v-data-table
                    :headers="headers_modal_repromaterijal"
                    :items="items_modal_repromaterijal"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props_modal">
                      <td v-if="props_modal.item.additive !== null">
                        {{ props_modal.item.additive.name }}
                      </td>
                      <td v-else>{{ "" }}</td>

                      <td>
                        {{
                          props_modal.item.quantity +
                          " " +
                          props_modal.item.unitOfMeasure.mark.replace(
                            "psc",
                            "kom"
                          )
                        }}
                      </td>

                      <td class="DataTable__ButtonHolder">
                        <img
                          class="DataTable__Button"
                          title="Izmena"
                          src="../assets/icons/zatabele/ico-edit2.svg"
                          alt="ulaz-grozdja"
                          @click="editRepromaterijalItemModal(props_modal.item)"
                          v-if="edit_form"
                        />

                        <img
                          class="DataTable__Button"
                          title="Pregled izdantnica"
                          src="../assets/icons/zatabele/ico-add.svg"
                          alt="delete-item"
                          @click="otvoriDialogIzdtnica(props_modal.item)"
                          v-if="edit_form"
                        />
                        <img
                          class="DataTable__Button"
                          title="Brisanje"
                          src="../assets/icons/zatabele/ico-delete2.svg"
                          alt="delete-item"
                          @click="
                            deleteRepromaterijalItemModal(props_modal.item)
                          "
                          v-if="edit_form"
                        />
                      </td>
                    </template>
                    <template slot="no-data">
                      <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                      <v-alert
                        slot="no-results"
                        :value="true"
                        color="primary"
                        icon="info"
                        >Nema podataka.</v-alert
                      >
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-form>
          </div>
          <!-- /.addingToTank -->
        </v-container>
      </v-dialog>

      <v-dialog
        v-model="dialogNote_operacije"
        scrollable
        content-class="ModalInModalGrafic"
      >
        <v-container style="padding: 0px">
          <div class="DataTable">
            <div data-v-fae5bece class="v-card">
              <AdditiveComponent
                @close="handleDataCloseOperacije($event)"
                :operationType="operacija"
              ></AdditiveComponent>
            </div>
          </div>
          <!-- /.addingToTank -->
        </v-container>
      </v-dialog>

      <TokenComponent ref="frmtoken" />
    </v-container>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import MyComponent from "../components/AddingNewComponent";

import AdditiveComponent from "../views/AdditiveItemComponentPom.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "WareHouseTurnBackWine",
  components: {
    TokenComponent,
    MyComponent,
    AdditiveComponent,
    Loading,
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    menu: "",
    menu1: "",
    time: "",
    date: null,
    valid: true,
    valid1: true,
    validModal: true,
    menuModal: "",
    menu1Modal: "",
    menuVazenja: "",
    menu1Vazenja: "",
    dateFormatted: null,
    dateFormattedKupovine: null,
    naziv: "",
    ID: 0,
    type: "",
    receive_id: 0,
    opis: "",
    employee_to_items: [],
    article_to_items: [],
    article_to_select: 0,
    wh_state_to_items: [],
    wh_state_to_select: 0,
    pomocni_text: "",
    give_to_select: 0,
    opis: "",
    dialogNote: false,
    index_izmene: -1,
    izmena_modal: true,
    quantity: undefined,
    // jm_items: [],
    // currency_items: [],
    // jm_valuta: undefined,
    items_modal: [],
    items_modal_repromaterijal: [],
    items_modal_repromaterijal_new: [],
    izabrani_aditivi: [],
    dodavanje_novog: true,
    items_modal_pom: [],
    headers_modal: [
      { text: "Vino", value: "wine.label", align: "center" },
      // { text: "Flaširano", value: "warehouseState.dateOfProduction" },
      { text: "Lot", value: "warehouseState.lot", align: "left" },
      // { text: "Tank", value: "warehouseState.tank" },
      {
        text: "Boca",
        value: "warehouseState.bottleVolumeInLitres",
        align: "left",
      },
      {
        text: "Broj boca",
        value: "quantity",
        align: "left",
        style: "width: 15%",
      },
      // { text: "JM", value: "width" },
      { text: "Funkcije", value: "funkcije", align: "center", sortable: false },
    ],
    headers_modal_repromaterijal: [
      {
        text: "Repromaterijal",
        value: "warehouseState.bottleVolumeInLitres",
        align: "left",
      },
      {
        text: "Količina",
        value: "quantity",
        align: "left",
        style: "width: 15%",
      },
      // { text: "JM", value: "width" },
      { text: "Funkcije", value: "funkcije", align: "center", sortable: false },
    ],
    warehouseID: 0,
    warehouseType: "",
    edit_form: true,
    executed_document: false,
    date_document: undefined,
    number: "",
    globBottlingID: 0,

    additiveQuantity: 0,
    jm: "",
    dialogNoteIzdatnice: false,
    selectedArticle: 0,
    selectedArticleName: "",
    materialOperationId: 0,
    documentID: 0,
    brojDec: 0,

    dialogNoteRepromaterijal: false,
    additiv_group_to_items: [],
    additiv_group_to_select: undefined,
    aditiv_items: [],
    aditiv_select: undefined,
    kolicina_modal: undefined,
    jm_select: undefined,
    jm_items_dodatak: [],
    opis_modal: "",
    index_izmene_repromaterijal: -1,
    load: 0,

    modal_lot: "",
    modal_zapremina: 0,
    pronadjiObjNovi: undefined,
    postoji: false,
    ID_aditiv: 0,

    ceoObjekatLansiranja: [],
    izabrano_vino_lot: undefined,
    novi_objekat_sa_izdatnicama: [],
    novi_objekat_sa_aditivima: [],
    novi_objekat_vino_lot: null,
    izabrani_aditiv: [],
    operacija: undefined,
    dialogNote_operacije: false,
  }),
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    handleDataCloseOperacije: function (e) {
      // this.getAllOperations(e.name);
      this.getAditives(this.additiv_group_to_select.id, e.name);
      this.dialogNote_operacije = false;
    },
    otvoriSifarnik(event) {
      if (this.additiv_group_to_select.id !== undefined)
        this.operacija = "Flaširanje|" + this.additiv_group_to_select.id;
      else this.operacija = "Flaširanje|" + this.additiv_group_to_select;

      this.dialogNote_operacije = true;
    },
    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    submit_parameter(e) {
      if (
        this.additiv_group_to_select === undefined ||
        this.additiv_group_to_select === ""
      )
        alert("Grupa repromaterijala mora biti unešena.");
      else if (this.aditiv_select === undefined || this.aditiv_select === "")
        alert("Repromaterijal mora biti unešen.");
      else if (this.kolicina_modal > 0 && this.jm_select !== undefined) {
        this.jm_select = {
          id: 10,
          name: "Komad",
          mark: "kom",
        };

        this.selectedArticle = this.aditiv_select.id;

        this.additiveQuantity = this.kolicina_modal;

        e.preventDefault();

        this.dialogNoteIzdatnice = true;

        if (this.jm_select.mark !== undefined) {
          this.jm = this.jm_select.mark.split("/")[0];

          if (this.jm === "kom") this.brojDec = 0;
          else this.brojDec = 2;
        }
      } else {
        alert("Količina i jedinica mere moraju biti unete.");
        // this.clear_modal_repromaterijal();
      }
    },
    getFieldTextJM(item) {
      let tekst = item.mark;

      if (item.mark === "psc") tekst = "kom";

      return tekst;
    },
    getAllGroups() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/additiv_group/operation/BOTTLING",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // // console.log(response.data);

          this.additiv_group_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/additiv_group/operation/BOTTLING",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.additiv_group_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAditives(a, aditivZaSelektovanje) {
      let url = "";

      if (this.operation === "BOTTLING")
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/additiv_group/" +
          a +
          "/additives";
      else
        url =
          this.globalServiceLocation +
          this.globalPort +
          "/additiv_group/" +
          a +
          "/additives";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.aditiv_items = response.data;

          if (
            aditivZaSelektovanje !== undefined &&
            aditivZaSelektovanje !== null
          ) {
            let ind = this.aditiv_items.findIndex(
              (x) => x.name === aditivZaSelektovanje
            );

            this.aditiv_select = this.aditiv_items[ind];
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.aditiv_items = response.data;

                      if (
                        aditivZaSelektovanje !== undefined &&
                        aditivZaSelektovanje !== null
                      ) {
                        let ind = this.aditiv_items.findIndex(
                          (x) => x.name === aditivZaSelektovanje
                        );

                        this.aditiv_select = this.aditiv_items[ind];
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    handleData: function (e) {
      if (
        this.materialOperationId !== 0 &&
        this.index_izmene_repromaterijal !== -1
      ) {
        this.getAllSifarnikRepromaterijal(this.materialOperationId);
      } else {
        let pomNiz = [];

        e.forEach(function (element) {
          pomNiz.push(element);
        });

        if (this.index_izmene_repromaterijal !== -1) {
          this.items_modal_repromaterijal[
            this.index_izmene_repromaterijal
          ].materialFromWarehouseDocumentItems = pomNiz;
        } else this.novi_objekat_sa_izdatnicama = pomNiz;
      }

      this.dialogNoteIzdatnice = false;

      this.additiveQuantity = 0;

      this.dodavanje_novog = true;
    },
    handleDataClose: function (e) {
      this.dialogNoteIzdatnice = false;

      if (this.novi_objekat_sa_izdatnicama.length === 0)
        alert("Nisu izabrane količine sa izdatnica.");
    },
    closeModal() {
      this.selectedArticle = undefined;
      this.dialogNoteIzdatnice = false;

      if (this.novi_objekat_sa_izdatnicama.length === 0)
        alert("Nisu izabrane količine sa izdatnica.");
    },
    otvoriDialogIzdtnica(item) {
      this.jm_select = {
        id: 10,
        name: "Komad",
        mark: "kom",
      };

      this.jm = this.jm_select.mark.split("/")[0];

      if (this.jm === "kom") this.brojDec = 0;
      else this.brojDec = 2;

      this.editRepromaterijalItemModal(item);

      this.dialogNoteIzdatnice = true;
    },
    changeAditiveGroup(a) {
      this.load = this.load + 1;
      if (this.load > 1) {
        this.selectedArticle = undefined;
        this.selectedArticleName = undefined;
        this.documentID = 0;
        this.kolicina_modal = undefined;
        this.jm_select = undefined;
      }

      if (typeof a !== "undefined") {
        if (a.id === undefined) {
          if (a !== undefined) {
            // this.PreostaloUTanku(a);
            this.getAditives(a);

            if (this.load > 1) this.aditiv_select = undefined;
            // this.bottleVolumeInLiters = 0;
          } else if (typeof this.operation_to_select === "undefined") {
            this.operation_to_select = undefined;
          }
        } else {
          this.getAditives(a.id);

          if (this.load > 1) this.aditiv_select = undefined;
          // this.bottleVolumeInLiters = 0;
        }
      }
    },

    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getFieldTextBottling(item) {
      let pomString = "";

      pomString = `${item.lot} - ${item.quantityState} boca`; // x ${item.bottleVolumeInLitres}l`;

      return pomString;
    },
    getFieldTextWine(item) {
      return `${item.label} ${item.year}`;
    },
    allowedStep: (m) => m % 5 === 0,
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    setTime() {
      const today = new Date();
      let Minutes = `${today.getMinutes()}`;
      let Hours = `${today.getHours()}`;

      if (Hours.length < 2) Hours = `0${Hours}`;
      if (Minutes.length < 2) Minutes = `0${Minutes}`;

      this.time = [Hours, Minutes].join(":");
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    wait: function (ms) {
      var start = Date.now(),
        now = start;
      while (now - start < ms) {
        now = Date.now();
      }
    },
    getAllJediniceMereAditiv(a) {
      if (typeof a !== "undefined")
        if (typeof a.id !== "undefined") {
          let ind = 0;
          ind = this.aditiv_items.findIndex((x) => x.id === a.id);

          if (ind >= 0) {
            this.selectedArticle = this.aditiv_items[ind].id;

            this.selectedArticleName = this.aditiv_items[ind].name;
          }

          this.$http
            .get(
              this.globalServiceLocation +
                this.globalPort +
                "/additiv/" +
                a.id +
                "/with_unit",
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization:
                    "Bearer  " + localStorage.getItem("user-token"),
                },
              }
            )
            .then((response) => {
              if (typeof a.bottleVolumeInLiters !== "undefined")
                this.bottleVolumeInLiters = a.bottleVolumeInLiters;

              this.jm_items_dodatak = response.data.unitOfMeasure;

              if (response.data.unitOfMeasure.length === 1)
                this.jm_select = response.data.unitOfMeasure[0];
            })
            .catch((e) => {
              // // console.log(e.response);

              if (!e.response) {
                alert(
                  this.$t("error.message")
                );
              } else {
                if (e.response.status === 401) {
                  this.$refs.frmtoken
                    .osvezavanjeTokena(
                      localStorage.getItem("user-refresh-token")
                    )
                    .then((result) => {
                      // // console.log(result);
                      // // console.log("Novi token - " + localStorage.getItem("user-token"));

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/additiv/" +
                            a.id +
                            "/with_unit",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          if (typeof a.bottleVolumeInLiters !== "undefined")
                            this.bottleVolumeInLiters = a.bottleVolumeInLiters;

                          this.jm_items_dodatak = response.data.unitOfMeasure;

                          if (response.data.unitOfMeasure.length === 1)
                            this.jm_select = response.data.unitOfMeasure[0];
                        })
                        .catch((e) => {
                          // // console.log(e.response);

                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        });
                    });
                } else {
                  let pomError = readJSON(e.response.data.message);
                  alert(pomError);
                }
              }
            });
        }
    },
    getAllEmployees() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/employee/all/basic",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.employee_to_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/employee/all/basic",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.employee_to_items = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getFieldText(item) {
      return `${item.firstName} ${item.lastName}`;
    },
    getAllArticles() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_state/wines/" +
            this.warehouseID,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.article_to_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_state/wines/" +
                        this.warehouseID,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.article_to_items = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    closeModalInModalRepromaterijal() {
      this.dialogNoteRepromaterijal = false;

      // this.additiveQuantity = 0;

      this.clear_modal_repromaterijal();
    },
    otvoriModalRepromaterijal(item) {
      this.izabrani_aditivi = [];

      if (item !== null) this.editItemModal(item);

      this.dialogNoteRepromaterijal = true;
    },
    popuni_izabrane_aditive(niz) {
      this.izabrani_aditivi = [];
      let index;
      let _this = this;

      if (niz !== undefined)
        niz.forEach(function (element) {
          // index = _this.izabrani_aditivi.indexOf(element);
          if (element.materialFromWarehouseDocumentItems.length > 0) {
            index = _this.izabrani_aditivi.findIndex(
              (x) =>
                x.additive.id === element.additive.id &&
                x.materialFromWarehouseDocumentItems[0].materialOperationId ===
                  element.materialFromWarehouseDocumentItems[0]
                    .materialOperationId &&
                x.materialFromWarehouseDocumentItems[0].warehouseInputOutputItem
                  .id ===
                  element.materialFromWarehouseDocumentItems[0]
                    .warehouseInputOutputItem.id
            );
          }

          if (index !== -1) _this.izabrani_aditivi.splice(index, index + 1);
          _this.izabrani_aditivi.push(element);
        });
    },
    getAllSifarnikRepromaterijal(idMaterial) {
      let _this = this;

      if (idMaterial != undefined && idMaterial != 0) {
        // // console.log(this.ID);

        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/warehouse_input_output/launching/additive/" +
              idMaterial,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            _this.ceoObjekatLansiranja.warehouseInputOutputItems[
              _this.index_izmene
            ].warehouseLaunchingAdditives = response.data;
            _this.items_modal_repromaterijal = response.data;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                _this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    _this.$http
                      .get(
                        _this.globalServiceLocation +
                          _this.globalPort +
                          "/warehouse_input_output/launching/additive/" +
                          idMaterial,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        _this.ceoObjekatLansiranja.warehouseInputOutputItems[
                          _this.index_izmene
                        ].warehouseLaunchingAdditives = response.data;
                        _this.items_modal_repromaterijal = response.data;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      } else {
        this.items_modal_repromaterijal = [];
        this.items_modal_repromaterijal_new = [];
      }
    },
    provera_repromaterijala() {
      let odgovor = false;

      console.log(this.ID_aditiv);

      if (
        this.aditiv_select.bottleVolumeInLiters !== null &&
        this.izmena_modal === false
      ) {
        let indeks;
        indeks = this.items_modal_repromaterijal.findIndex(
          (x) =>
            x.additive.bottleVolumeInLiters !== null &&
            x.additiv.bottleVolumeInLiters !== undefined
        );

        if (indeks !== -1) odgovor = true;
      }

      return odgovor;
    },
    submit_modal_repromaterijal() {
      if (
        this.novi_objekat_sa_izdatnicama.length === 0 &&
        this.index_izmene_repromaterijal < 0
      )
        alert("Niste izabrali izdatnice sa kojih se uzima repromaterijal.");
      else if (this.$refs.form_modal_repromaterijal.validate()) {
        if (this.provera_repromaterijala()) {
          alert(
            "Flaširanje nije moguće izvršiti za više tipova boca odjednom."
          );
          this.dialogNote = true;
        } else {
          var complexPouringAdditiv;

          if (this.index_izmene < 0) {
            this.pouring_quantity =
              Number(this.bottleVolumeInLiters) * Number(this.kolicina_modal);
            this.jm_dolivanja_select = {
              id: 2,
            };

            var complexObjectUnitOfMeasure = {
              id: this.jm_select.id,
              mark: this.jm_select.mark,
            };

            var complexAdditiv;

            if (this.additiv_group_to_select.enumLabel === "bottle")
              complexAdditiv = {
                id: this.aditiv_select.id,
                additiveGroup: this.additiv_group_to_select,
                name: this.aditiv_select.name,
                bottleVolumeInLiters: this.bottleVolumeInLiters,
              };
            else
              complexAdditiv = {
                id: this.aditiv_select.id,
                additiveGroup: this.additiv_group_to_select,
                name: this.aditiv_select.name,
              };

            let opis = "";
            if (this.opis_modal === undefined) opis = this.opis_modal;

            if (this.index_izmene_repromaterijal < 0)
              complexPouringAdditiv = {
                additive: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: opis,
                materialFromWarehouseDocumentItems:
                  this.novi_objekat_sa_izdatnicama,
              };
            else
              complexPouringAdditiv = {
                additive: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: opis,
                materialFromWarehouseDocumentItems:
                  this.novi_objekat_sa_aditivima[
                    this.index_izmene_repromaterijal
                  ].materialFromWarehouseDocumentItems,
              };

            this.items_modal_repromaterijal = [];

            if (this.novi_objekat_vino_lot !== null) {
              if (this.index_izmene_repromaterijal !== -1) {
                this.novi_objekat_vino_lot.warehouseLaunchingAdditives.splice(
                  this.index_izmene_repromaterijal,
                  this.index_izmene_repromaterijal + 1
                );
              }

              this.novi_objekat_vino_lot.warehouseLaunchingAdditives.push(
                complexPouringAdditiv
              );
            } else {
              if (this.index_izmene_repromaterijal !== -1) {
                this.novi_objekat_sa_aditivima.splice(
                  this.index_izmene_repromaterijal,
                  this.index_izmene_repromaterijal + 1
                );
              }

              this.novi_objekat_sa_aditivima.push(complexPouringAdditiv);
              this.items_modal_repromaterijal = this.novi_objekat_sa_aditivima;
            }

            // if(this.index_izmene < 0)
            //   this.novi_objekat_sa_aditivima = complexPouringAdditiv
            // else{
            //   this.novi_objekat_vino_lot.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives.push(complexPouringAdditiv);
            // }

            this.clear_modal_repromaterijal();
          } else if (this.ID === 0) {
            this.pouring_quantity =
              Number(this.bottleVolumeInLiters) * Number(this.kolicina_modal);
            this.jm_dolivanja_select = {
              id: 2,
            };

            var complexObjectUnitOfMeasure = {
              id: this.jm_select.id,
              mark: this.jm_select.mark,
            };

            var complexAdditiv;

            if (this.additiv_group_to_select.enumLabel === "bottle")
              complexAdditiv = {
                id: this.aditiv_select.id,
                additiveGroup: this.additiv_group_to_select,
                name: this.aditiv_select.name,
                bottleVolumeInLiters: this.bottleVolumeInLiters,
              };
            else
              complexAdditiv = {
                id: this.aditiv_select.id,
                additiveGroup: this.additiv_group_to_select,
                name: this.aditiv_select.name,
              };

            let opis = "";
            if (this.opis_modal === undefined) opis = this.opis_modal;

            if (this.novi_objekat_sa_izdatnicama.length > 0)
              complexPouringAdditiv = {
                additive: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: opis,
                materialFromWarehouseDocumentItems:
                  this.novi_objekat_sa_izdatnicama,
              };
            else
              complexPouringAdditiv = {
                additive: complexAdditiv,
                quantity: Number(this.kolicina_modal),
                unitOfMeasure: complexObjectUnitOfMeasure,
                description: opis,
                materialFromWarehouseDocumentItems:
                  this.novi_objekat_sa_aditivima[
                    this.index_izmene_repromaterijal
                  ].materialFromWarehouseDocumentItems,
              };

            if (this.index_izmene < 0) {
              this.novi_objekat_vino_lot.warehouseLaunchingAdditives.push(
                complexPouringAdditiv
              );
              this.items_modal_repromaterijal =
                this.novi_objekat_vino_lot.warehouseLaunchingAdditives;
            } else {
              if (this.index_izmene_repromaterijal !== -1) {
                this.novi_objekat_sa_aditivima.splice(
                  this.index_izmene_repromaterijal,
                  this.index_izmene_repromaterijal + 1
                );
              }

              this.novi_objekat_sa_aditivima.push(complexPouringAdditiv);

              this.ceoObjekatLansiranja.warehouseInputOutputItems[
                this.index_izmene
              ].warehouseLaunchingAdditives = this.novi_objekat_sa_aditivima;

              this.items_modal_repromaterijal = this.novi_objekat_sa_aditivima;
            }

            // if(this.index_izmene < 0)
            //   this.novi_objekat_sa_aditivima = complexPouringAdditiv
            // else{
            //   this.novi_objekat_vino_lot.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives.push(complexPouringAdditiv);
            // }

            this.clear_modal_repromaterijal();
          } else {
            var complexPouringAdditivNew;

            if (Number(this.index_izmene_repromaterijal) === -1) {
              var complexObjectUnitOfMeasure = {
                id: this.jm_select.id,
              };
              var complexObjectUnitOfMeasurePom = {
                id: this.jm_select,
              };

              var complexAdditiv;
              var complexPouringAdditivPom;

              if (this.additiv_group_to_select.enumLabel === "bottle") {
                complexAdditiv = {
                  id: this.aditiv_select.id,
                  bottleVolumeInLiters: this.bottleVolumeInLiters,
                };

                complexPouringAdditivPom = {
                  id: this.aditiv_select.id,
                  bottleVolumeInLiters: this.bottleVolumeInLiters,
                };
              } else {
                complexAdditiv = {
                  id: this.aditiv_select.id,
                };

                complexPouringAdditivPom = this.aditiv_select;
              }

              if (typeof this.opis_modal === "undefined")
                complexPouringAdditivNew = {
                  warehouseInputOutputItemId: this.materialOperationId,
                  additive: {
                    id: complexAdditiv.id,
                  },
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasure,
                  description: "",
                  materialFromWarehouseDocumentItems:
                    this.novi_objekat_sa_izdatnicama,
                };
              else
                complexPouringAdditivNew = {
                  warehouseInputOutputItemId: this.materialOperationId,
                  additive: {
                    id: complexAdditiv.id,
                  },
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasure,
                  description: this.opis_modal,
                  materialFromWarehouseDocumentItems:
                    this.novi_objekat_sa_izdatnicama,
                };

              if (typeof this.opis_modal === "undefined")
                complexPouringAdditiv = {
                  pouringId: this.ID,
                  additive: complexPouringAdditivPom,
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasurePom,
                  description: "",
                  materialFromWarehouseDocumentItems:
                    this.novi_objekat_sa_izdatnicama,
                };
              else
                complexPouringAdditiv = {
                  pouringId: this.ID,
                  additive: complexPouringAdditivPom,
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasurePom,
                  description: this.opis_modal,
                  materialFromWarehouseDocumentItems:
                    this.novi_objekat_sa_izdatnicama,
                };

              let _this = this;

              this.$http
                .post(
                  this.globalServiceLocation +
                    this.globalPort +
                    "/warehouse_launching_additive/create",
                  complexPouringAdditivNew,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization:
                        "Bearer  " + localStorage.getItem("user-token"),
                    },
                  }
                )
                .then((response) => {
                  this.getAllSifarnikRepromaterijal(this.materialOperationId);

                  this.clear_modal_repromaterijal();
                })
                .catch((e) => {
                  // // console.log(e.response);

                  if (!e.response) {
                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          // // console.log(result);
                          // // console.log("Novi token - " + localStorage.getItem("user-token"));

                          this.$http
                            .post(
                              this.globalServiceLocation +
                                this.globalPort +
                                "/warehouse_launching_additive/create",
                              complexPouringAdditivNew,
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization:
                                    "Bearer  " +
                                    localStorage.getItem("user-token"),
                                },
                              }
                            )
                            .then((response) => {
                              //       this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives.push(complexPouringAdditiv);

                              // this.items_modal_repromaterijal = this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives;
                              this.getAllSifarnikRepromaterijal(
                                this.materialOperationId
                              );
                              this.clear_modal_repromaterijal();
                            })
                            .catch((e) => {
                              // // console.log(e.response);

                              let pomError = readJSON(e.response.data.message);
                              alert(pomError);
                            });
                        });
                    } else {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    }
                  }
                });
            } else {
              var complexObjectUnitOfMeasure = {
                id: this.jm_select.id,
              };

              var complexAdditiv;

              if (this.additiv_group_to_select.enumLabel === "bottle")
                complexAdditiv = {
                  id: this.aditiv_select.id,
                  bottleVolumeInLiters: this.bottleVolumeInLiters,
                };
              else
                complexAdditiv = {
                  id: this.aditiv_select.id,
                };

              if (typeof this.opis_modal === "undefined")
                complexPouringAdditivNew = {
                  id: this.ceoObjekatLansiranja.warehouseInputOutputItems[
                    this.index_izmene
                  ].warehouseLaunchingAdditives[
                    this.index_izmene_repromaterijal
                  ].id,
                  warehouseInputOutputItemId: this.materialOperationId,
                  additive: {
                    id: complexAdditiv.id,
                  },
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasure,
                  description: "",
                };
              else
                complexPouringAdditivNew = {
                  id: this.ceoObjekatLansiranja.warehouseInputOutputItems[
                    this.index_izmene
                  ].warehouseLaunchingAdditives[
                    this.index_izmene_repromaterijal
                  ].id,
                  warehouseInputOutputItemId: this.materialOperationId,
                  additive: {
                    id: complexAdditiv.id,
                  },
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasure,
                  description: this.opis_modal,
                };

              if (typeof this.opis_modal === "undefined")
                complexPouringAdditiv = {
                  id: this.ceoObjekatLansiranja.warehouseInputOutputItems[
                    this.index_izmene
                  ].warehouseLaunchingAdditives[
                    this.index_izmene_repromaterijal
                  ].id,
                  pouringId: this.ID,
                  additive: complexAdditiv,
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasure,
                  description: "",
                  materialFromWarehouseDocumentItems:
                    this.novi_objekat_sa_izdatnicama,
                };
              else
                complexPouringAdditiv = {
                  id: this.ceoObjekatLansiranja.warehouseInputOutputItems[
                    this.index_izmene
                  ].warehouseLaunchingAdditives[
                    this.index_izmene_repromaterijal
                  ].id,
                  pouringId: this.ID,
                  additive: complexAdditiv,
                  quantity: Number(this.kolicina_modal),
                  unitOfMeasure: complexObjectUnitOfMeasure,
                  description: this.opis_modal,
                  materialFromWarehouseDocumentItems:
                    this.novi_objekat_sa_izdatnicama,
                };

              if (
                this.additiv_group_to_select.enumLabel === "bottle" &&
                Number(this.pouring_quantity) !==
                  Number(this.bottleVolumeInLiters) *
                    Number(this.kolicina_modal)
              ) {
                // if (
                //   confirm(
                //     "Nije jednaka ukupana količina vina i broj boca puta njihova zapremina. Da li želite da izvršite snimanje?"
                //   )
                // ) {
                // if (this.additiv_group_to_select.enumLabel === "bottle") {
                // if (
                //   this.additiv_group_to_select.enumLabel === "bottle" &&
                //   confirm(
                //     "Da li želite izmenom količine flaša da promenite i količinu vina koja je flaširana?"
                //   )
                // )
                this.$http
                  .put(
                    this.globalServiceLocation +
                      this.globalPort +
                      "/warehouse_launching_additive/update",
                    complexPouringAdditivNew,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    }
                  )
                  .then((response) => {
                    this.ceoObjekatLansiranja.warehouseInputOutputItems[
                      this.index_izmene
                    ].warehouseLaunchingAdditives[
                      this.index_izmene_repromaterijal
                    ].quantity = Number(this.kolicina_modal);
                    this.ceoObjekatLansiranja.warehouseInputOutputItems[
                      this.index_izmene
                    ].warehouseLaunchingAdditives[
                      this.index_izmene_repromaterijal
                    ].description = this.opis_modal;

                    this.items_modal_repromaterijal =
                      this.ceoObjekatLansiranja.warehouseInputOutputItems[
                        this.index_izmene
                      ].warehouseLaunchingAdditives;

                    this.clear_modal_repromaterijal();
                  })
                  .catch((e) => {
                    // // console.log(e.response);

                    if (!e.response) {
                      alert(
                        this.$t("error.message")
                      );
                    } else {
                      if (e.response.status === 401) {
                        this.$refs.frmtoken
                          .osvezavanjeTokena(
                            localStorage.getItem("user-refresh-token")
                          )
                          .then((result) => {
                            // // console.log(result);
                            // // console.log("Novi token - " + localStorage.getItem("user-token"));

                            this.$http
                              .put(
                                this.globalServiceLocation +
                                  this.globalPort +
                                  "/warehouse_launching_additive/update",
                                complexPouringAdditivNew,
                                {
                                  headers: {
                                    "Content-Type": "application/json",
                                    Authorization:
                                      "Bearer  " +
                                      localStorage.getItem("user-token"),
                                  },
                                }
                              )
                              .then((response) => {
                                this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                  this.index_izmene
                                ].warehouseLaunchingAdditives[
                                  this.index_izmene_repromaterijal
                                ].quantity = Number(this.kolicina_modal);
                                this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                  this.index_izmene
                                ].warehouseLaunchingAdditives[
                                  this.index_izmene_repromaterijal
                                ].description = this.opis_modal;

                                this.items_modal_repromaterijal =
                                  this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                    this.index_izmene
                                  ].warehouseLaunchingAdditives;

                                this.clear_modal_repromaterijal();
                              })
                              .catch((e) => {
                                // // console.log(e.response);

                                let pomError = readJSON(
                                  e.response.data.message
                                );
                                alert(pomError);
                              });
                          });
                      } else {
                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      }
                    }
                  });
                // else {
                //   this.$http
                //     .put(
                //       this.globalServiceLocation +
                //         this.globalPort +
                //         "/warehouse_launching_additive/update",
                //       complexPouringAdditivNew,
                //       {
                //         headers: {
                //           "Content-Type": "application/json",
                //           Authorization:
                //             "Bearer  " + localStorage.getItem("user-token"),
                //         },
                //       }
                //     )
                //     .then((response) => {
                //       this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives[this.index_izmene_repromaterijal].quantity = Number(this.kolicina_modal);
                //       this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives[this.index_izmene_repromaterijal].description = this.opis_modal;

                //       this.items_modal_repromaterijal = this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives;

                //       this.clear_modal_repromaterijal();
                //     })
                //     .catch((e) => {
                //       // // console.log(e.response);

                //       if (!e.response) {
                //         alert(
                //           this.$t("error.message")
                //         );
                //       } else {
                //         if (e.response.status === 401) {
                //           this.$refs.frmtoken
                //             .osvezavanjeTokena(
                //               localStorage.getItem("user-refresh-token")
                //             )
                //             .then((result) => {
                //               // // console.log(result);
                //               // // console.log("Novi token - " + localStorage.getItem("user-token"));

                //               this.$http
                //                 .put(
                //                   this.globalServiceLocation +
                //                     this.globalPort +
                //                     "/warehouse_launching_additive/update",
                //                   complexPouringAdditivNew,
                //                   {
                //                     headers: {
                //                       "Content-Type": "application/json",
                //                       Authorization:
                //                         "Bearer  " +
                //                         localStorage.getItem("user-token"),
                //                     },
                //                   }
                //                 )
                //                 .then((response) => {
                //                   this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives[this.index_izmene_repromaterijal].quantity = Number(this.kolicina_modal);
                //       this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives[this.index_izmene_repromaterijal].description = this.opis_modal;

                //       this.items_modal_repromaterijal = this.ceoObjekatLansiranja.warehouseInputOutputItems[this.index_izmene].warehouseLaunchingAdditives;

                //       this.clear_modal_repromaterijal();
                //                 })
                //                 .catch((e) => {
                //                   // // console.log(e.response);

                //                   let pomError = readJSON(
                //                     e.response.data.message
                //                   );
                //                   alert(pomError);
                //                 });
                //             });
                //         } else {
                //           let pomError = readJSON(e.response.data.message);
                //           alert(pomError);
                //         }
                //       }
                //     });
                // }
                // }
              } else {
                if (this.additiv_group_to_select.enumLabel === "bottle") {
                  // if (
                  //   confirm(
                  //     "Da li želite izmenom količine flaša da promenite i količinu vina koja je flaširana?"
                  //   )
                  // )
                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_launching_additive/update",
                      complexPouringAdditivNew,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.ceoObjekatLansiranja.warehouseInputOutputItems[
                        this.index_izmene
                      ].warehouseLaunchingAdditives[
                        this.index_izmene_repromaterijal
                      ].quantity = Number(this.kolicina_modal);
                      this.ceoObjekatLansiranja.warehouseInputOutputItems[
                        this.index_izmene
                      ].warehouseLaunchingAdditives[
                        this.index_izmene_repromaterijal
                      ].description = this.opis_modal;

                      this.items_modal_repromaterijal =
                        this.ceoObjekatLansiranja.warehouseInputOutputItems[
                          this.index_izmene
                        ].warehouseLaunchingAdditives;

                      this.clear_modal_repromaterijal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      if (!e.response) {
                        alert(
                          this.$t("error.message")
                        );
                      } else {
                        if (e.response.status === 401) {
                          this.$refs.frmtoken
                            .osvezavanjeTokena(
                              localStorage.getItem("user-refresh-token")
                            )
                            .then((result) => {
                              // // console.log(result);
                              // // console.log("Novi token - " + localStorage.getItem("user-token"));

                              this.$http
                                .put(
                                  this.globalServiceLocation +
                                    this.globalPort +
                                    "/warehouse_launching_additive/update",
                                  complexPouringAdditivNew,
                                  {
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization:
                                        "Bearer  " +
                                        localStorage.getItem("user-token"),
                                    },
                                  }
                                )
                                .then((response) => {
                                  this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                    this.index_izmene
                                  ].warehouseLaunchingAdditives[
                                    this.index_izmene_repromaterijal
                                  ].quantity = Number(this.kolicina_modal);
                                  this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                    this.index_izmene
                                  ].warehouseLaunchingAdditives[
                                    this.index_izmene_repromaterijal
                                  ].description = this.opis_modal;

                                  this.items_modal_repromaterijal =
                                    this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                      this.index_izmene
                                    ].warehouseLaunchingAdditives;

                                  this.clear_modal_repromaterijal();
                                })
                                .catch((e) => {
                                  // // console.log(e.response);

                                  let pomError = readJSON(
                                    e.response.data.message
                                  );
                                  alert(pomError);
                                });
                            });
                        } else {
                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        }
                      }
                    });
                } else {
                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_launching_additive/update",
                      complexPouringAdditivNew,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.ceoObjekatLansiranja.warehouseInputOutputItems[
                        this.index_izmene
                      ].warehouseLaunchingAdditives[
                        this.index_izmene_repromaterijal
                      ].quantity = Number(this.kolicina_modal);
                      this.ceoObjekatLansiranja.warehouseInputOutputItems[
                        this.index_izmene
                      ].warehouseLaunchingAdditives[
                        this.index_izmene_repromaterijal
                      ].description = this.opis_modal;

                      this.items_modal_repromaterijal =
                        this.ceoObjekatLansiranja.warehouseInputOutputItems[
                          this.index_izmene
                        ].warehouseLaunchingAdditives;

                      this.clear_modal_repromaterijal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      if (!e.response) {
                        alert(
                          this.$t("error.message")
                        );
                      } else {
                        if (e.response.status === 401) {
                          this.$refs.frmtoken
                            .osvezavanjeTokena(
                              localStorage.getItem("user-refresh-token")
                            )
                            .then((result) => {
                              // // console.log(result);
                              // // console.log("Novi token - " + localStorage.getItem("user-token"));

                              this.$http
                                .put(
                                  this.globalServiceLocation +
                                    this.globalPort +
                                    "/warehouse_launching_additive/update",
                                  complexPouringAdditivNew,
                                  {
                                    headers: {
                                      "Content-Type": "application/json",
                                      Authorization:
                                        "Bearer  " +
                                        localStorage.getItem("user-token"),
                                    },
                                  }
                                )
                                .then((response) => {
                                  this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                    this.index_izmene
                                  ].warehouseLaunchingAdditives[
                                    this.index_izmene_repromaterijal
                                  ].quantity = Number(this.kolicina_modal);
                                  this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                    this.index_izmene
                                  ].warehouseLaunchingAdditives[
                                    this.index_izmene_repromaterijal
                                  ].description = this.opis_modal;

                                  this.items_modal_repromaterijal =
                                    this.ceoObjekatLansiranja.warehouseInputOutputItems[
                                      this.index_izmene
                                    ].warehouseLaunchingAdditives;

                                  this.clear_modal_repromaterijal();
                                })
                                .catch((e) => {
                                  // // console.log(e.response);

                                  let pomError = readJSON(
                                    e.response.data.message
                                  );
                                  alert(pomError);
                                });
                            });
                        } else {
                          let pomError = readJSON(e.response.data.message);
                          alert(pomError);
                        }
                      }
                    });
                }
              }
            }
          }
        }

        this.dialogNoteRepromaterijal = true;
      }
    },
    clear_modal_repromaterijal() {
      this.index_izmene_repromaterijal = -1;
      this.$refs.form_modal_repromaterijal.reset();

      this.izmena_modal = false;
      // alert('ocisti modal')

      // this.materialOperationId = 0;
      this.selectedArticle = 0;
      this.selectedArticleName = "";

      this.documentID = 0;

      this.additiveQuantity = 0;

      this.dodavanje_novog = true;

      this.index_izmene_repromaterijal = -1;
      this.novi_objekat_sa_izdatnicama = [];

      this.izabrani_aditivi = [];
    },
    getAllWareHouseState(a) {
      let _this = this;
      let url = "/warehouse_state/lots/" + this.warehouseID + "/" + a;

      if (this.executed_document)
        url = url + "?lot=" + this.modal_lot + "&date=" + this.date_document;

      this.$http
        .get(this.globalServiceLocation + this.globalPort + url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          _this.wh_state_to_items = response.data;

          if (
            _this.globBottlingID !== 0 &&
            _this.globBottlingID !== undefined
          ) {
            let pronadjiObj = _this.wh_state_to_items.find(
              (item1) => item1.stateId === _this.globBottlingID
            );

            if (pronadjiObj !== undefined)
              _this.wh_state_to_select = pronadjiObj;
            else {
              if (_this.wh_state_to_items.length !== 0) {
                if (
                  _this.modal_lot !== "" &&
                  _this.modal_lot !== null &&
                  _this.modal_lot !== undefined
                ) {
                  pronadjiObj = _this.wh_state_to_items.filter(function (
                    item1
                  ) {
                    return item1.lot === _this.modal_lot;
                  });

                  if (pronadjiObj.length > 0) {
                    pronadjiObj[0].quantityState = pronadjiObj[0].quantityState; //+ _this.quantity;
                    _this.wh_state_to_select = pronadjiObj[0];
                  } else if (_this.postoji) {
                    let pomObj = {
                      articleId: _this.pronadjiObjNovi.id,
                      bottleVolumeInLitres: _this.modal_zapremina,
                      lot: _this.modal_lot,
                      materialInputId: null,
                      price: null,
                      quantityState: this.quantity,
                      quantityStateInLitres: null,
                      stateId: _this.globBottlingID,
                      unitOfMeasure: {
                        id: null,
                        mark: null,
                        name: null,
                      },
                      validTo: null,
                      value: null,
                    };

                    _this.wh_state_to_items.push(pomObj);
                    _this.wh_state_to_select = pomObj;
                  }
                }

                if (response.data.length === 1)
                  _this.wh_state_to_select = response.data[0];
              } else {
                let pomObj = {
                  articleId: _this.pronadjiObjNovi.id,
                  bottleVolumeInLitres: _this.modal_zapremina,
                  lot: _this.modal_lot,
                  materialInputId: null,
                  price: null,
                  quantityState: this.quantity,
                  quantityStateInLitres: null,
                  stateId: _this.globBottlingID,
                  unitOfMeasure: {
                    id: null,
                    mark: null,
                    name: null,
                  },
                  validTo: null,
                  value: null,
                };

                _this.wh_state_to_items.push(pomObj);
                _this.wh_state_to_select = pomObj;
              }
            }
          } else if (response.data.length === 1)
            _this.wh_state_to_select = response.data[0];
          else {
            if (_this.wh_state_to_items.length !== 0) {
              if (
                _this.modal_lot !== "" &&
                _this.modal_lot !== null &&
                _this.modal_lot !== undefined
              ) {
                let pronadjiObj;

                pronadjiObj = response.data.filter(function (item1) {
                  return item1.lot === _this.modal_lot;
                });

                if (pronadjiObj.length > 0 && _this.executed_document) {
                  // pronadjiObj[0].bottlesUnreceived =
                  //   pronadjiObj[0].bottledNumber;

                  pronadjiObj[0].bottlesUnreceived =
                    pronadjiObj[0].bottlesUnreceived + _this.quantity;
                } else {
                  let pomObj = {
                    bottledNumber: 0,
                    bottlesUnreceived: _this.quantity,
                    lot: _this.modal_lot,
                    bottleVolumeInLiters: _this.modal_zapremina,
                    bottlingId: null,
                  };

                  _this.wh_state_to_items.push(pomObj);
                  _this.wh_state_to_select = pomObj;
                }
              }

              if (response.data.length === 1)
                _this.wh_state_to_select = response.data[0];
            }
          }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(this.globalServiceLocation + this.globalPort + url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      _this.wh_state_to_items = response.data;

                      if (
                        _this.globBottlingID !== 0 &&
                        _this.globBottlingID !== undefined
                      ) {
                        let pronadjiObj = _this.wh_state_to_items.find(
                          (item1) => item1.stateId === _this.globBottlingID
                        );

                        if (pronadjiObj !== undefined)
                          _this.wh_state_to_select = pronadjiObj;
                        else {
                          if (_this.wh_state_to_items.length !== 0) {
                            if (
                              _this.modal_lot !== "" &&
                              _this.modal_lot !== null &&
                              _this.modal_lot !== undefined
                            ) {
                              pronadjiObj = _this.wh_state_to_items.filter(
                                function (item1) {
                                  return item1.lot === _this.modal_lot;
                                }
                              );

                              if (pronadjiObj.length > 0) {
                                pronadjiObj[0].quantityState =
                                  pronadjiObj[0].quantityState; //+ _this.quantity;
                                _this.wh_state_to_select = pronadjiObj[0];
                              } else if (_this.postoji) {
                                let pomObj = {
                                  articleId: _this.pronadjiObjNovi.id,
                                  bottleVolumeInLitres: _this.modal_zapremina,
                                  lot: _this.modal_lot,
                                  materialInputId: null,
                                  price: null,
                                  quantityState: this.quantity,
                                  quantityStateInLitres: null,
                                  stateId: _this.globBottlingID,
                                  unitOfMeasure: {
                                    id: null,
                                    mark: null,
                                    name: null,
                                  },
                                  validTo: null,
                                  value: null,
                                };

                                _this.wh_state_to_items.push(pomObj);
                                _this.wh_state_to_select = pomObj;
                              }
                            }

                            if (response.data.length === 1)
                              _this.wh_state_to_select = response.data[0];
                          } else {
                            let pomObj = {
                              articleId: _this.pronadjiObjNovi.id,
                              bottleVolumeInLitres: _this.modal_zapremina,
                              lot: _this.modal_lot,
                              materialInputId: null,
                              price: null,
                              quantityState: this.quantity,
                              quantityStateInLitres: null,
                              stateId: _this.globBottlingID,
                              unitOfMeasure: {
                                id: null,
                                mark: null,
                                name: null,
                              },
                              validTo: null,
                              value: null,
                            };

                            _this.wh_state_to_items.push(pomObj);
                            _this.wh_state_to_select = pomObj;
                          }
                        }
                      } else if (response.data.length === 1)
                        _this.wh_state_to_select = response.data[0];
                      else {
                        if (_this.wh_state_to_items.length !== 0) {
                          if (
                            _this.modal_lot !== "" &&
                            _this.modal_lot !== null &&
                            _this.modal_lot !== undefined
                          ) {
                            let pronadjiObj;

                            pronadjiObj = response.data.filter(function (
                              item1
                            ) {
                              return item1.lot === _this.modal_lot;
                            });

                            if (
                              pronadjiObj.length > 0 &&
                              _this.executed_document
                            ) {
                              // pronadjiObj[0].bottlesUnreceived =
                              //   pronadjiObj[0].bottledNumber;

                              pronadjiObj[0].bottlesUnreceived =
                                pronadjiObj[0].bottlesUnreceived +
                                _this.quantity;
                            } else {
                              let pomObj = {
                                bottledNumber: 0,
                                bottlesUnreceived: _this.quantity,
                                lot: _this.modal_lot,
                                bottleVolumeInLiters: _this.modal_zapremina,
                                bottlingId: null,
                              };

                              _this.wh_state_to_items.push(pomObj);
                              _this.wh_state_to_select = pomObj;
                            }
                          }

                          if (response.data.length === 1)
                            _this.wh_state_to_select = response.data[0];
                        }
                      }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeWine(a) {
      if (typeof a !== "undefined") {
        // this.jm_select = a.unitOfMeasure;

        if (this.pronadjiObjNovi !== a) this.postoji = false;

        if (typeof a.id !== "undefined") this.getAllWareHouseState(a.id);
        else this.getAllWareHouseState(a);
      }
    },
    otvoriModal() {
      this.dialogNote = true;
      this.getAllArticles();

      this.clear_modal();
    },

    closeModalInModal() {
      this.dialogNote = false;

      this.clear_modal();
    },
    submit_modal() {
      if (this.$refs.form_modal.validate()) {
        let pronadjiObjNovi;

        if (this.ID > 0)
          pronadjiObjNovi = this.items_modal_pom.findIndex(
            (item1) =>
              item1.articleId === this.wh_state_to_select.articleId &&
              item1.lot === this.wh_state_to_select.lot
          );
        else
          pronadjiObjNovi = this.items_modal_pom.findIndex(
            (item1) =>
              item1.wine.id === this.wh_state_to_select.articleId &&
              item1.warehouseState.lot === this.wh_state_to_select.lot
          );

        if (
          Number(this.wh_state_to_select.quantityState) >= Number(this.quantity)
        ) {
          if (pronadjiObjNovi !== -1 && this.index_izmene === -1)
            alert("Izabrano vino i lot već se nalaze u listi.");
          else if (
            this.index_izmene !== -1 &&
            this.index_izmene !== pronadjiObjNovi &&
            pronadjiObjNovi !== -1
          )
            alert("Izabrano vino i lot već se nalaze u listi.");
          else {
            var complexPouringAdditiv;

            var pom_artikal;

            if (
              typeof this.article_to_select !== "undefined" &&
              this.article_to_select !== ""
            ) {
              if (typeof this.article_to_select.id === "undefined")
                pom_artikal = this.article_to_select;
              else pom_artikal = this.article_to_select.id;
            }

            var pom_wmState;

            if (
              typeof this.wh_state_to_select !== "undefined" &&
              this.wh_state_to_select !== ""
            ) {
              if (typeof this.wh_state_to_select.stateId === "undefined")
                pom_wmState = this.wh_state_to_select;
              else pom_wmState = this.wh_state_to_select.stateId;
            }

            var complexPouringAdditivPom;
            complexPouringAdditivPom = {
              wine: this.article_to_select,
              quantity: Number(this.quantity),
              warehouseState: this.wh_state_to_select,
              warehouseLaunchingAdditives: this.novi_objekat_sa_aditivima,
            };

            if (this.index_izmene !== -1 && this.ID !== 0) {
              complexPouringAdditiv =
                this.ceoObjekatLansiranja.warehouseInputOutputItems[
                  this.index_izmene
                ];
              complexPouringAdditiv.warehouseState.id = pom_wmState;
              complexPouringAdditiv.quantity = Number(this.quantity);
              complexPouringAdditiv.warehouseLaunchingAdditives =
                this.novi_objekat_sa_aditivima;

              // pronadjiObjNovi = this.items_modal_pom.findIndex(
              //   (item1) =>
              //     item1.warehouseState.stateId ===
              //     complexPouringAdditiv.warehouseState.id
              // );
            } else {
              complexPouringAdditiv = {
                warehouseState: {
                  id: pom_wmState,
                },
                quantity: Number(this.quantity),
                warehouseLaunchingAdditives: this.novi_objekat_sa_aditivima,
              };

              let pomNiz = [];

              let itemIndex = 0;

              if (
                this.ceoObjekatLansiranja.warehouseInputOutputItems !==
                undefined
              ) {
                pomNiz = this.ceoObjekatLansiranja.warehouseInputOutputItems;
                itemIndex =
                  this.ceoObjekatLansiranja.warehouseInputOutputItems.length;
              }

              // pronadjiObjNovi = this.items_modal_pom.findIndex(
              //   (item1) =>
              //     item1.warehouseState.stateId ===
              //     complexPouringAdditiv.warehouseState.id
              // );

              if (pronadjiObjNovi < 0) pomNiz.push(complexPouringAdditivPom);

              this.ceoObjekatLansiranja.warehouseInputOutputItems = pomNiz;

              if (pronadjiObjNovi < 0)
                this.ceoObjekatLansiranja.warehouseInputOutputItems.splice(
                  itemIndex,
                  1,
                  complexPouringAdditivPom
                );

              this.items_modal_pom =
                this.ceoObjekatLansiranja.warehouseInputOutputItems;
            }

            if (this.ID !== 0)
              if (this.index_izmene !== -1) {
                // ovde treba da ide poziv nove procedure za izmenu
                this.edit_modal(complexPouringAdditiv, this.type);
              } else {
                // ovde treba da ide poziv nove procedure za unos stavke
                this.add_modal(complexPouringAdditiv, this.type);
              }
            else {
              // if (this.index_izmene !== -1) {
              //   this.items_modal.splice(this.index_izmene, 1);
              //   this.items_modal_pom.splice(this.index_izmene, 1);
              // }

              // this.items_modal.push(complexPouringAdditiv);
              // this.items_modal_pom.push(complexPouringAdditivPom);

              // this.novi_objekat_vino_lot = complexPouringAdditivPom;

              this.clear_modal();
            }
          }
        } else alert("Izabrali ste veću količinu od raspoložive.");
      }
    },
    clear_modal() {
      this.index_izmene = -1;

      this.$refs.form_modal.reset();
      //this.$refs.form_modal_1.reset();

      this.izmena_modal = false;
      // alert('ocisti modal')

      this.globBottlingID = 0;
      this.wh_state_to_items = [];

      this.modal_lot = "";
      this.modal_zapremina = 0;
      this.pronadjiObjNovi = undefined;
      this.postoji = false;

      this.materialOperationId = 0;

      this.items_modal_repromaterijal = [];
      this.items_modal_repromaterijal_new = [];

      this.izabrano_vino_lot = undefined;
      this.novi_objekat_sa_izdatnicama = [];
      this.novi_objekat_sa_aditivima = [];
      this.novi_objekat_vino_lot = null;

      this.izabrani_aditivi = [];
    },
    clearInit() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();
      this.$refs.element1.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];
    },
    clear() {
      this.setTime();
      this.setDate();

      this.$refs.form.reset();
      this.$refs.element1.reset();

      this.ID = 0;

      this.items_modal = [];
      this.items_modal_pom = [];

      let naslov = "";

      naslov = "Lansiranje";

      document.getElementById("naslov").innerText = naslov;

      this.ceoObjekatLansiranja = [];

      this.izabrani_aditivi = [];
    },
    deleteItemModalPom(item) {
      confirm("Da li želite da obrišete izabranu stavku?") &&
        this.deleteItemModal(item);
    },
    deleteItemModal(item) {
      if (item.id !== undefined) {
        let url = "/warehouse_input_output_item/delete/" + item.id;

        this.$http
          .delete(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            // // // console.log(response);
            alert("Stavka je uspešno obrisana.");

            // this.obrisiAditive(item);

            this.getAllItem(this.ID);
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .delete(
                        this.globalServiceLocation + this.globalPort + url,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // // console.log(response);
                        alert("Stavka je uspešno obrisana.");

                        // this.obrisiAditive(item);

                        this.getAllItem(this.ID);
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      } else {
        const index = this.items_modal_pom.indexOf(item);
        this.items_modal_pom.splice(index, 1);

        this.items_modal.splice(index, 1);

        this.obrisiAditive(item);
      }
    },
    obrisiAditive(item) {
      this.index_izmene =
        this.ceoObjekatLansiranja.warehouseInputOutputItems.indexOf(item);

      let pomInd =
        this.izabrano_vino_lot.warehouseLaunchingAdditives.indexOf(item);

      this.ceoObjekatLansiranja.warehouseInputOutputItems.splice(
        this.index_izmene_repromaterijal,
        this.index_izmene_repromaterijal + 1
      );
      this.izabrano_vino_lot.warehouseLaunchingAdditives.splice(
        pomInd,
        pomInd + 1
      );
    },
    edit_modal(locObject, type) {
      let complexInput = this.vrati_objekat(locObject, type, false);
      let url;

      if (!this.executed_document) url = "/warehouse_input_output_item/update";
      else url = "/warehouse_input_output/update_executed";

      this.$http
        .put(this.globalServiceLocation + this.globalPort + url, complexInput, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation + this.globalPort + url,
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnikExcecuted() {
      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;
      complexInput = {
        id: this.ID,
        number: this.number,
        warehouse: complexObjectWareHouse,
        date: this.date + "T" + this.time,
        type: this.type,
        give: complexObjectGive,
        description: this.opis,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/update_executed",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;

          if (this.warehouseType === "bottled_wine")
            poruka = "Uspešno je izmenjen dokument broj " + this.number + ".";
          else
            poruka = "Uspešno je izmenjen dokument broj " + this.number + ".";

          //alert(poruka);

          this.clear();
        })
        .catch((e) => {
          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/update_executed",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;

                      if (this.warehouseType === "bottled_wine")
                        poruka =
                          "Uspešno je izmenjen dokument broj " +
                          this.number +
                          ".";
                      else
                        poruka =
                          "Uspešno je izmenjen dokument broj " +
                          this.number +
                          ".";

                      //alert(poruka);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    add_modal(locObject, type) {
      let complexInput = this.vrati_objekat(locObject, type, true);

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output_item/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllItem(this.ID);

          this.dialogNote = false;
          this.clear_modal();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output_item/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllItem(this.ID);

                      this.dialogNote = false;
                      this.clear_modal();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              // console.log(e.response);
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    vrati_objekat(newObject, type, newItem) {
      if (newItem)
        newObject.wine = {
          id: this.article_to_select.id,
        };

      var pomArray = [];
      pomArray.push(newObject);

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;

      if (newItem) {
        complexInput = {
          id: this.ID,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: this.type,
          warehouseInputOutputItems: pomArray,
        };
      } else {
        complexInput = {
          id: this.ID,
          number: this.number,
          warehouse: complexObjectWareHouse,
          date: this.date + "T" + this.time,
          type: this.type,
          give: complexObjectGive,
          description: this.opis,
          warehouseInputOutputItems: pomArray,
        };
      }
      return complexInput;
    },
    newSifarnik() {
      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      let nizInputOutputa = [];

      this.ceoObjekatLansiranja.warehouseInputOutputItems.forEach((element) => {
        let elem = {
          quantity: element.quantity,
          warehouseState: {
            id: element.warehouseState.stateId,
          },
          wine: {
            id: element.wine.id,
          },
          warehouseLaunchingAdditives: element.warehouseLaunchingAdditives,
        };

        nizInputOutputa.push(elem);
      });

      var complexInput;
      complexInput = {
        warehouse: complexObjectWareHouse,
        date: this.date + "T" + this.time,
        type: this.type,
        give: complexObjectGive,
        description: this.opis,
        warehouseInputOutputItems: nizInputOutputa,
      };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/create",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;
          let pom_poruka;

          pom_poruka = "lansiranje";

          let naslov = document.getElementById("naslov").innerText;
          document.getElementById("naslov").innerText =
            naslov + " " + response.data.documentNumber;

          setTimeout(() => {
            this.wait(500);
            if (this.warehouseType === "bottled_wine")
              poruka =
                "Uspešno je kreiran dokument broj " +
                response.data.documentNumber +
                ". Da li želite da izvršite " +
                pom_poruka +
                " vina iz magacina?";
            else
              poruka =
                "Uspešno je kreiran dokument broj " +
                response.data.documentNumber +
                ". Da li želite da izvršite " +
                pom_poruka +
                " materijala iz magacina?";

            confirm(poruka) && this.prijemDokumenta(response.data.id);

            this.clear();
          }, 10);
        })
        .catch((e) => {
          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/create",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;
                      let pom_poruka;

                      pom_poruka = "lansiranje";

                      let naslov = document.getElementById("naslov").innerText;
                      document.getElementById("naslov").innerText =
                        naslov + " " + response.data.documentNumber;

                      setTimeout(() => {
                        this.wait(500);
                        if (this.warehouseType === "bottled_wine")
                          poruka =
                            "Uspešno je kreiran dokument broj " +
                            response.data.documentNumber +
                            ". Da li želite da izvršite " +
                            pom_poruka +
                            " vina iz magacina?";
                        else
                          poruka =
                            "Uspešno je kreiran dokument broj " +
                            response.data.documentNumber +
                            ". Da li želite da izvršite " +
                            pom_poruka +
                            " materijala iz magacina?";

                        confirm(poruka) &&
                          this.prijemDokumenta(response.data.id);

                        this.clear();
                      }, 10);
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    prijemDokumenta(id) {
      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/execute/" +
            id,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          alert("Dokument je uspešno izvršen.");
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/execute/" +
                        id,
                      null,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      alert("Dokument je uspešno izvršen.");
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      // alert("Izmena");

      var pom_give_to_select;

      if (
        typeof this.give_to_select !== "undefined" &&
        this.give_to_select !== ""
      ) {
        if (typeof this.give_to_select.id === "undefined")
          pom_give_to_select = this.give_to_select;
        else pom_give_to_select = this.give_to_select.id;
      }

      var complexObjectGive = {
        id: pom_give_to_select,
      };

      var complexObjectWareHouse = {
        id: this.warehouseID,
      };

      var complexInput;
      complexInput = {
        id: this.ID,
        number: this.number,
        warehouse: complexObjectWareHouse,
        date: this.date + "T" + this.time,
        type: this.type,
        give: complexObjectGive,
        description: this.opis,
        warehouseInputOutputItems: this.items_modal,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/update",
          complexInput,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.isLoading = false;

          let poruka;
          let pom_poruka;

          pom_poruka = "lansiranje";

          if (this.warehouseType === "bottled_wine")
            poruka =
              "Uspešno je kreiran dokument broj " +
              this.number +
              ". Da li želite da izvršite " +
              pom_poruka +
              " vina na stanje magacina?";
          else
            poruka =
              "Uspešno je kreiran dokument broj " +
              this.number +
              ". Da li želite da izvršite " +
              pom_poruka +
              " materijala na stanje magacina?";

          confirm(poruka) && this.prijemDokumenta(this.ID);

          this.clear();
        })
        .catch((e) => {
          if (!e.response) {
            this.isLoading = false;

            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/update",
                      complexInput,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.isLoading = false;

                      let poruka;
                      let pom_poruka;

                      pom_poruka = "lansiranje";

                      if (this.warehouseType === "bottled_wine")
                        poruka =
                          "Uspešno je kreiran dokument broj " +
                          this.number +
                          ". Da li želite da izvršite " +
                          pom_poruka +
                          " vina na stanje magacina?";
                      else
                        poruka =
                          "Uspešno je kreiran dokument broj " +
                          this.number +
                          ". Da li želite da izvršite " +
                          pom_poruka +
                          " materijala na stanje magacina?";

                      confirm(poruka) && this.prijemDokumenta(this.ID);

                      this.clear();
                    })
                    .catch((e) => {
                      this.isLoading = false;

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              this.isLoading = false;

              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    editRepromaterijalItemModal(item) {
      this.dodavanje_novog = false;

      // this.dialogNoteRepromaterijal = true;

      this.load = 0;

      this.izmena_modal = true;

      this.izabrani_aditiv = item;
      this.index_izmene_repromaterijal =
        this.items_modal_repromaterijal.indexOf(item);

      this.kolicina_modal = item.quantity;
      this.pouring_quantity = item.quantity;

      this.jm_select = item.unitOfMeasure;
      this.opis_modal = item.description;

      this.documentID = item.id;
      this.additiveQuantity = item.quantity;

      this.jm = item.unitOfMeasure.mark.split("/")[0];

      if (this.jm === "kom") this.brojDec = 0;
      else this.brojDec = 2;

      if (item.additive !== null) {
        this.additiv_group_to_select = item.additive.additiveGroup;
        this.aditiv_select = item.additive;
        this.bottleVolumeInLiters = item.additive.bottleVolumeInLiters;

        this.selectedArticle = item.additive.id;

        this.selectedArticleName = item.additive.name;

        if (item.materialFromWarehouseDocumentItems.length > 0)
          this.novi_objekat_sa_izdatnicama =
            item.materialFromWarehouseDocumentItems;
      }

      let pomNiz = [];
      pomNiz.push(item);
      this.popuni_izabrane_aditive(pomNiz);
    },
    deleteRepromaterijalItemModal(item) {
      if (item.bottleVolumeInLiters !== null) this.prviTipBoce = true;

      const index = this.items_modal.indexOf(item);
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.deleteSifarnik(index, item.id);
    },
    deleteSifarnik(id, id_aditiv) {
      if (this.ID === 0) {
        this.items_modal_repromaterijal.splice(id, 1);
        this.items_modal_repromaterijal_new.splice(id, 1);
      } else {
        this.$http
          .delete(
            this.globalServiceLocation +
              this.globalPort +
              "/warehouse_launching_additive/" +
              id_aditiv,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.getAllSifarnikRepromaterijal(this.materialOperationId);
            this.clear_modal_repromaterijal();
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .delete(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/warehouse_launching_additive/" +
                          id_aditiv,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(response);

                        this.getAllSifarnikRepromaterijal(
                          this.materialOperationId
                        );
                        this.clear_modal_repromaterijal();
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    editItemModal(item, bool) {
      // this.clear_modal_repromaterijal();

      this.izabrano_vino_lot = item;
      this.index_izmene =
        this.ceoObjekatLansiranja.warehouseInputOutputItems.indexOf(item);

      this.items_modal_repromaterijal =
        this.izabrano_vino_lot.warehouseLaunchingAdditives;

      this.materialOperationId = item.id;

      this.dialogNote = bool;

      if (item.warehouseState.stateId !== undefined) {
        this.globBottlingID = item.warehouseState.stateId;
        this.modal_lot = item.warehouseState.lot;
        this.modal_zapremina = item.warehouseState.bottleVolumeInLitres;
      } else {
        this.globBottlingID = item.warehouseState.id;
        this.modal_lot = item.lot;
        this.modal_zapremina = item.bottleVolumeInLitres;
      }

      if (item.wineName !== undefined)
        this.pronadjiObjNovi = this.article_to_items.find(
          (item1) =>
            item1.label === item.wineName && item1.year === item.wineYear
        );
      else
        this.pronadjiObjNovi = this.article_to_items.find(
          (item1) =>
            item1.label === item.wine.label && item1.year === item.wine.year
        );

      this.article_to_select = this.pronadjiObjNovi;

      this.quantity = Number(item.quantity);
    },
    submit() {
      if (
        this.ceoObjekatLansiranja.length > 0 &&
        this.ceoObjekatLansiranja.warehouseInputOutputItems === undefined
      )
        alert("Nije izabrano ni jedno flasiranje.");
      else {
        this.items_modal = this.ceoObjekatLansiranja.warehouseInputOutputItems;

        if (this.$refs.form1.validate())
          if (this.items_modal.length < 1)
            alert("Niste izabrali ni jednu stavku dokumenta/artikal.");
          else {
            this.isLoading = true;

            setTimeout(() => {
              if (this.ID != "" && this.ID != "0") {
                if (this.executed_document) this.changeSifarnikExcecuted();
                else this.changeSifarnik();
              } else this.newSifarnik();
            }, 1000);
          }
      }
    },
    getAllItem(id) {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/warehouse_input_output/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_modal_pom = response.data.warehouseInputOutputItems;
          this.ceoObjekatLansiranja = response.data;
          this.ID = response.data.id;
          this.give_to_select = response.data.give;
          this.opis = response.data.description;
          this.date = response.data.date.split("T")[0];
          this.time = this.formatTime(response.data.date.split("T")[1]);

          this.izabrani_aditivi = [];
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_input_output/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.ceoObjekatLansiranja = response.data;
                      this.ID = response.data.id;
                      this.give_to_select = response.data.give;
                      this.opis = response.data.description;
                      this.date = response.data.date.split("T")[0];
                      this.time = this.formatTime(
                        response.data.date.split("T")[1]
                      );

                      this.izabrani_aditivi = [];
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
  },
  beforeMount() {
    serverBus.$on("wh_launch", (id, tip_magacina, idAction, item) => {
      this.warehouseID = id;
      this.warehouseType = tip_magacina;

      this.type = "LAUNCH";

      if (item !== null) {
        this.getAllArticles();
        // this.getAllJediniceMere();

        this.edit_form = item.edit;
        this.executed_document = item.executed;
        this.date_document = item.date;

        this.number = item.number;
        this.getAllItem(item.id);
      }
    });
  },
  mounted() {
    this.clearInit();
    this.getAllEmployees();
    this.getAllGroups();
  },

  destroyed() {
    serverBus.$off("wh_launch");
  },
};
</script>

<style lang="scss" scoped>
@import "./parts/../../assets/sass/parts/modalStyles";

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

.v-btn {
  min-width: 0;
}
#Odustani_dugme {
  text-align: right !important;
}

#FloatingButton {
  position: absolute;
  width: 54px;
  height: 54px;
  font-size: 25px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  // transition: .2s ease-in-out;
  // p {
  //   position: relative;
  //   width: 100%;
  //   height: 100%;
  //   i {
  //     position: absolute;
  //     left: 6px;
  //     top: 6px;
  //     transform: rotate(45deg);
  //     color: #ffffff;
  //   }
  // }
  &:active,
  &:focus {
    box-shadow: none;
  }
}
</style>
